import api from "./index";

export async function getWheels(params) {
  return api.get(`/wheels/last`, { params });
}

export async function spinWheel(wheelID) {
  return api.post(`/wheels/${wheelID}/spin`);
}

export async function canWheelSpin(wheelID, params) {
  return api.get(`/wheels/${wheelID}/can-spin`, { params });
}

export async function getHistoryWheel(params) {
  return api.get("/wheels/history", { params });
}
